<template>
  <span>
    <DatePicker
      class="datepicker"
      type="daterange"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      range-separator="-"
      v-model="defaultBaseTime"
      :clearable="false"
      :picker-options="pickerOptions"
      @change="handleBaseTimeChange"
    />

    <Checkbox class="checkbox" v-model="showContrast" @change="handleCheckboxChange">时间对比</Checkbox>

    <DatePicker
      class="datepicker"
      v-if="showContrast"
      type="daterange"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      range-separator="-"
      v-model="defaultContrastTime"
      :clearable="false"
      :picker-options="pickerOptions"
      @change="handleContrastTimeChange"
    />
  </span>
</template>

<script>
import { DatePicker, Checkbox } from 'element-ui';
import moment from 'moment';

const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';

export default {
  components: {
    DatePicker,
    Checkbox
  },

  props: {
    defaultDate: {
      type: Array,
      required: true
    }
  },

  data() {
    this.getContrastTime();
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '昨天',
            onClick(picker) {
              picker.$emit('pick', [moment().subtract(1, 'day'), moment().subtract(1, 'day')]);
            }
          },
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', [moment(), moment()]);
            }
          },
          {
            text: '最近7天',
            onClick(picker) {
              picker.$emit('pick', [moment().subtract(7, 'day'), moment().subtract(1, 'day')]);
            }
          },
          {
            text: '最近30天',
            onClick(picker) {
              picker.$emit('pick', [moment().subtract(30, 'day'), moment().subtract(1, 'day')]);
            }
          },
          {
            text: '本周',
            onClick(picker) {
              picker.$emit('pick', [moment().weekday(1), moment().weekday(moment().weekday() - 1)]);
            }
          },
          {
            text: '上周',
            onClick(picker) {
              picker.$emit('pick', [moment().weekday(-6), moment().weekday(0)]);
            }
          },
          {
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [moment().startOf('month'), moment()]);
            }
          },
          {
            text: '上个月',
            onClick(picker) {
              const lastMonth = moment().month() - 1;
              picker.$emit('pick', [
                moment()
                  .month(lastMonth)
                  .startOf('month'),
                moment()
                  .month(lastMonth)
                  .endOf('month')
              ]);
            }
          }
        ]
      },
      defaultBaseTime: this.defaultDate,
      defaultContrastTime: [moment().subtract(60, 'day'), moment().subtract(31, 'day')],
      showContrast: false
    };
  },

  methods: {
    getContrastTime() {
      const start = moment(this.defaultDate[0]);
      const end = moment(this.defaultDate[1]);
      const interval = end.diff(start, 'days');
      this.defaultContrastTime = [start.subtract(1 + interval, 'day'), end.subtract(1, 'day')];
    },

    // 调整基本时间
    // 会联动调整对比时间
    handleBaseTimeChange([start, end]) {
      const interval = moment(end).diff(moment(start), 'days');
      const s1 = moment(start).subtract(1 + interval, 'day');
      const e1 = moment(start).subtract(1, 'day');
      this.defaultContrastTime = [s1, e1];

      const list = [];
      list.push({
        type: 'base',
        start: moment(start).format(DEFAULT_DATE_FORMAT),
        end: moment(end).format(DEFAULT_DATE_FORMAT)
      });

      if (this.showContrast) {
        list.push({
          type: 'contrast',
          start: s1.format(DEFAULT_DATE_FORMAT),
          end: e1.format(DEFAULT_DATE_FORMAT)
        });
      }

      this.$emit('change', list);
    },

    handleContrastTimeChange([start, end]) {
      const interval = moment(end).diff(moment(start), 'days');
      const s1 = moment(end).add(1, 'day');
      const e1 = moment(end).add(1 + interval, 'day');
      this.defaultBaseTime = [s1, e1];
      this.$emit('change', [
        {
          type: 'contrast',
          start: moment(start).format(DEFAULT_DATE_FORMAT),
          end: moment(end).format(DEFAULT_DATE_FORMAT)
        },
        {
          type: 'base',
          start: moment(s1).format(DEFAULT_DATE_FORMAT),
          end: moment(e1).format(DEFAULT_DATE_FORMAT)
        }
      ]);
    },

    handleCheckboxChange(val) {
      if (val) {
        const [start, end] = this.defaultContrastTime;
        this.$emit('checkbox-change', {
          type: 'contrast',
          start: start.format(DEFAULT_DATE_FORMAT),
          end: end.format(DEFAULT_DATE_FORMAT)
        });
      } else {
        this.$emit('checkbox-change', {
          type: 'contrast',
          start: undefined,
          end: undefined
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.checkbox {
  margin: 0px 10px;
}

.datepicker {
  width: 250px;
}
</style>
